import gql from 'graphql-tag';
import { CustomerOrderFragment, MealPlanFragment } from '../fragments';

const FetchCustomer = gql`
  query fetchCustomer($id: Int) {
    Customer(id: $id) {
        id
        username
        email
        loginStatus
        firstName
        lastName
        address
        city
        state
        zipCode
        phone
        mobile
        createdDate
      }
    }
  `;

const FetchCustomerMealPlans = gql`
  query fetchCustomerMealPlans($id: Int) {
    Customer(id: $id) {
      mealPlans {
        ...MealPlan
      }
    }
  }

  ${MealPlanFragment}
`;

const FetchCustomerOrders = gql`
  query fetchCustomerOrders($id: Int, $ordersFrom: Int, $ordersLimit: Int) {
    Customer(id: $id) {
      orders(from: $ordersFrom, limit: $ordersLimit) {
        ...CustomerOrder
      }
    }
  }

  ${CustomerOrderFragment}
`;

const FetchFullCustomer = gql`
  query fetchFullCustomer($id: Int, $ordersFrom: Int, $ordersLimit: Int) {
    Customer(id: $id) {
      id
      username
      email
      loginStatus
      firstName
      lastName
      address
      city
      state
      zipCode
      phone
      mobile
      createdDate
      mealPlans {
        ...MealPlan
      }
      orders(from: $ordersFrom, limit: $ordersLimit) {
        ...CustomerOrder
      }
    }
  }

  ${MealPlanFragment}
  ${CustomerOrderFragment}
`;

export { 
  FetchCustomer, 
  FetchCustomerOrders, 
  FetchCustomerMealPlans,
  FetchFullCustomer 
};


// WEBPACK FOOTER //
// ./src/graphql/queries/customer.js